// AOS.init();

Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
});

$(document).ready(function(){
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 10) {
            $('.navbar').addClass('header-fixed');
        }
        else {
            $('.navbar').removeClass('header-fixed');
        }
    });

    $(".SerachBtn").click(function() {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').addClass("active");      //add the class to the clicked element
        $('body').addClass("overflow");      //add the class to the clicked element
    });
    $(".CSM-close").click(function() {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').removeClass("active");      //add the class to the clicked element
        $('body').removeClass("overflow");      //add the class to the clicked element
    });

    // var divisor = document.getElementById("divisor"),
    //     slider = document.getElementById("slider");
    //     function moveDivisor() { 
    //         divisor.style.width = slider.value+"%";
    // }    
});

$(document).ready(function () {
    // $('.category-ImgTxtArrow').on('click', function (e) {
    $('.category-arrow').on('click', function (e) {
        e.preventDefault();
        // const $parent = $(this).parent();
        const $parent = $(this).parent().parent();
        const isActive = $parent.hasClass('active');

        // Remove 'active' from all siblings
        $parent.siblings().removeClass('active');

        // Toggle 'active' only on the clicked one
        $parent.toggleClass('active', !isActive);
    });
});

// $('.banner-slider').owlCarousel({
//     loop: true,
//     margin: 10,
//     nav: false,
//     dots: true,
//     autoplay: true,
//     navText: ['<i class="fa-solid fa-arrow-left"></i>','<i class="fa-solid fa-arrow-right"></i>'],
//     autoplayTimeout: 8000,
//     autoplaySpeed: 2500,
//     smartSpeed: 2500,
//     animateOut: 'fadeOut',
//     animateIn: 'fadeIn',
//     autoplayHoverPause: false,
//     responsiveClass: true,
//     responsive:{
//         0:{
//             items: 1,
//         },
//         576:{
//             items: 1,
//         },
//         767:{
//             items: 1,
//         },
//         992:{
//             items: 1,
//         },
//         1200:{
//             items: 1,
//         },
//         1400:{
//             items: 1,
//         },
//         1600:{
//             items: 1,
//         },
//     }
// });

// $(".banner-slider").on("initialized.owl.carousel changed.owl.carousel", function(e) {
//     if (!e.namespace) {
//         return;
//     }
//     $("#counter").html(
//         e.relatedTarget.relative(e.item.index) + 1 + "<span>" + "/" + e.item.count + "</span>"
//     );
// }).owlCarousel({
//     loop: true,
//     margin: 6,
//     nav: false,
//     dots: true,
//     autoplay: false,
//     navText: ['<i class="fa-solid fa-arrow-left"></i>','<i class="fa-solid fa-arrow-right"></i>'],
//     autoplayTimeout: 8000,
//     autoplaySpeed: 2500,
//     smartSpeed: 2500,
//     animateOut: 'fadeOut',
//     animateIn: 'fadeIn',
//     autoplayHoverPause: false,
//     responsiveClass: true,
//     responsive:{
//         0:{
//             items: 1,
//         },
//         576:{
//             items: 1,
//         },
//         767:{
//             items: 1,
//         },
//         992:{
//             items: 1,
//         },
//         1200:{
//             items: 1,
//         },
//         1400:{
//             items: 1,
//         },
//         1600:{
//             items: 1,
//         },
//     }
// });

// banner slider js

$('.ShopBCate-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: true,
    center: true,
    navText: ['<i class="bi bi-arrow-left"></i>','<i class="bi bi-arrow-right"></i>'],
    autoplayTimeout: 6000,
    autoplaySpeed: 2000,
    smartSpeed: 2000,
    // animateOut: 'pulseOut',
    // animateIn: 'pulseIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive:{
        0:{
            items: 1,
            nav: false,
        },
        576:{
            items: 2,
            nav: false,
        },
        767:{
            items: 2.8,
        },
        992:{
            items: 4.6,
        },
        1200:{
            items: 5.8,
        },
        1400:{
            items: 6.1,
        },
        1600:{
            items: 6.1,
        },
    }
});

$('.Brands-slider').owlCarousel({
    loop: true,
    margin: 15,
    nav: false,
    dots: false,
    autoplay: true,
    navText: ['<i class="fa-solid fa-chevron-left"></i>','<i class="fa-solid fa-chevron-right"></i>'],
    autoplayTimeout: 5000,
    autoplaySpeed: 3000,
    smartSpeed: 2500,
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive:{
        0:{
            items: 1,
        },
        320:{
            items: 2,
        },
        580:{
            items: 3,
        },
        767:{
            items: 4,
        },
        992:{
            items: 5,
        },
        1200:{
            items: 6,
        },
        1400:{
            items: 7,
        }
    }
});